import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { omit, isEmpty, toArray } from 'lodash';
import { withRouter } from 'react-router';
import { length } from 'redux-form-validators';

import { USERNAME_MIN_LENGTH, USERNAME_MAX_LENGTH, EMAIL_LENGTH } from '../../../constants/form';
import {
    FormComponent,
    EmailInputFieldComponent,
    PasswordInputFieldComponent,
    TextInputFieldComponent,
    CheckboxInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { PATH } from '../../../constants/path';
import { BRAND_NAME } from '../../../constants';
import { FRANCE } from '../../../constants/countries';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { MADAME, MONSIEUR } from '../../../constants/civilities';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';
import { registerUser } from '../../../services/authentication/register/actions';
import { fetchBankCreditCardIfNeeded } from '../../../services/bankcreditcard/actions';

import './RegisterFormComponent.scss';

const CONFIRMATIONS_FIELD_NAME = ['emailconfirm', 'passwordconfirm', 'cguacceptance'];

class RegisterFormComponent extends React.Component {
    componentDidMount() {
        const { fetchBankCreditCardIfNeeded } = this.props;

        fetchBankCreditCardIfNeeded();
    }

    submit = values => {
        this.props.registerUser(omit(values, CONFIRMATIONS_FIELD_NAME), () => {
            this.props.history.push('/');
        });
    };

    getCivilities = () => {
        const { i18nCommon } = this.props;

        return [
            { label: i18nCommon.CIVILITIES.MONSIEUR, value: MONSIEUR },
            { label: i18nCommon.CIVILITIES.MADAME, value: MADAME }
        ];
    };

    getCountries = () => {
        const { i18nCommon } = this.props;

        return [{ label: i18nCommon.COUNTRIES.FRANCE, value: FRANCE }];
    };

    getBanks = () => {
        const { bankcreditcard } = this.props;

        return bankcreditcard.map(item => ({ label: item.bankLabel, value: item.bankId }));
    };

    render() {
        const {
            errorMessage,
            i18n,
            i18nCommon,
            requestSubmit,
            successSubmit,
            errorSubmit
        } = this.props;

        const sponsor = sessionStorage.getItem('sponsor') ? sessionStorage.getItem('sponsor') : '';

        if (!successSubmit) {
            return (
                <FormComponent
                    form="register-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    initialValues={{ godfather: sponsor }}
                    className="register-form"
                    submitText={i18n.BUTTON_REGISTER}>
                    <TextInputFieldComponent
                        name="username"
                        classNameInputContainer="two-thirds"
                        placeholder={i18nCommon.PLACEHOLDER_USERNAME}
                        label={i18nCommon.LABEL_USERNAME}
                        isRequired
                        validate={[
                            length({
                                min: USERNAME_MIN_LENGTH,
                                msg: format(i18nCommon.USERNAME_SIZE_MIN_ERROR, USERNAME_MIN_LENGTH)
                            }),
                            length({
                                max: USERNAME_MAX_LENGTH,
                                msg: format(i18nCommon.USERNAME_SIZE_MAX_ERROR, USERNAME_MAX_LENGTH)
                            })
                        ]}
                    />

                    <EmailInputFieldComponent
                        name="email"
                        classNameInputContainer="two-thirds"
                        placeholder={i18nCommon.PLACEHOLDER_EMAIL}
                        label={i18nCommon.LABEL_EMAIL}
                        isRequired
                        validate={[
                            length({
                                max: EMAIL_LENGTH,
                                msg: format(i18nCommon.EMAIL_SIZE_ERROR, EMAIL_LENGTH)
                            })
                        ]}
                    />

                    <PasswordInputFieldComponent
                        name="password"
                        classNameInputContainer="two-thirds"
                        placeholder={i18nCommon.PLACEHOLDER_PASSWORD}
                        label={i18nCommon.LABEL_PASSWORD}
                        isRequired
                    />

                    <TextInputFieldComponent
                        name="godfather"
                        classNameInputContainer="two-thirds"
                        placeholder={i18nCommon.PLACEHOLDER_GODFATHER}
                        label={i18nCommon.LABEL_GODFATHER}
                    />
                    <CheckboxInputFieldComponent
                        name="newsletterSubscribe"
                        options={[{ label: format(i18n.NEWSLETTER_TEXT, BRAND_NAME), value: 1 }]}
                    />
                    <CheckboxInputFieldComponent
                        name="cguacceptance"
                        options={[
                            {
                                label: (
                                    <div>
                                        {i18n.CGU_TEXT_1}&nbsp;
                                        <LocalizedNavLink to={PATH.TERMS_PATH}>
                                            {i18n.CGU_TEXT_2}
                                        </LocalizedNavLink>
                                    </div>
                                ),
                                value: 1
                            }
                        ]}
                        minRequired={1}
                    />
                    <LegendFieldComponent classNameInputContainer="full txtright">
                        {i18nCommon.TEXT_REQUIRED_FIELD}
                    </LegendFieldComponent>
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </FormComponent>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.REGISTER_SUCCESS}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        errorMessage: state.authentication.error,
        requestSubmit: state.authentication.fetching || false,
        successSubmit: state.authentication.isAuthenticated,
        errorSubmit: !isEmpty(state.authentication.error),
        i18n: state.i18n.page.register,
        i18nCommon: state.i18n.feature.form,
        bankcreditcard: toArray(state.bankcreditcard.bankcreditcard)
    };
}

const mapDispatchToProps = {
    registerUser,
    fetchBankCreditCardIfNeeded
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterFormComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/register/RegisterFormComponent.js